import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type BulkApproveDlnsPayload,
  type BulkApproveDlnsResponse,
} from './types';
import {
  zodBulkApproveDlnsEndpointSchema,
  zodBulkApproveDlnsPayloadSchema,
  zodSuccessResponseSchema,
} from './validations';

/**
 * Bulk-approves delivery notes.
 *
 * @param payload - The delivery notes to approve with approve/disapprove flag.
 * @param options - Optional request options (e.g. abort signal).
 * @returns The API success response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/bulk_approve_dlns_delivery_note_bulk_approve_put
 */
export const bulkApproveDlns = async (
  payload: BulkApproveDlnsPayload,
  options?: KyRequestOptions,
): Promise<BulkApproveDlnsResponse> => {
  const response = await vestigasApi
    .put(ENDPOINT.DELIVERY_NOTE.BULK_APPROVE_DLNS(), {
      json: payload,
      validate: {
        body: zodBulkApproveDlnsPayloadSchema,
        pathSegments: zodBulkApproveDlnsEndpointSchema,
      },
      ...options,
    })
    .json<BulkApproveDlnsResponse>();

  return zodSuccessResponseSchema.parse(response);
};
